import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import Check from '@material-ui/icons/Check';
import StepConnector from '@material-ui/core/StepConnector';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  icon: {
    color: "#003a4d !important"
  },
  circle: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    cursor: 'pointer'
  },
  h1: {
    fontSize:'20px !important', 
    marginLeft:'15px', 
    cursor: 'pointer', 
    color:'#f7941e'
  },
  h2:{
    fontSize:'20px !important', 
    color:'#f7941e' , 
    marginLeft:'15px', 
    cursor: 'pointer', 
    marginTop: '6px'
  },
  otherDiv:{
    fontSize:'20px', 
    color:'#f7941e',
    marginLeft:'15px', 
    cursor: 'pointer'
  },
  checkIcon:{
    fontSize:'20px !important',
    marginRight: 10,
    marginTop: -5
  }
}));



const QontoConnector = withStyles({
  active: {
    '& $line': {
      borderColor: '#003a4d',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#003a4d',
    },
  },
  line: {
    borderRadius: 1,
  },
  circle: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    cursor: 'pointer'
  }
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#003a4d',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#003a4d',
  },
  circle: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
    cursor: 'pointer'
  },
  completed: {
    color: '#003a4d',
    zIndex: 1,
    fontSize: 18,
  }
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

export default function VerticalLinearStepper(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(2);

  const handleNext = (key) => {
    if(key===1||key===2){

    }
    else if(activeStep === (key))
    {
      setActiveStep(key-1);
    }
    else
    {
      setActiveStep(key);
    }
  };

  return (
    <div className={classes.root}>
      <Stepper orientation="vertical" activeStep={activeStep} connector={<QontoConnector />}>
        {props.data.map((index) => (
          <Step key={index["id"]} active={(parseInt(index["id"])===2||parseInt(index["id"])===1||parseInt(index["id"])===activeStep)?true:false}>
            <StepLabel StepIconComponent={QontoStepIcon}
                style={{color: ' !important'}} onClick={()=>handleNext(parseInt(index["id"]))}>
                {index["headingTag"] === "h1" ? 
                <h1 className={classes.h1}>{index["label"]}</h1>
                : index["headingTag"] === "h2" ?
                <h2 className={classes.h2}>{index["label"]}</h2>
                :<div className={classes.otherDiv}>{index["label"]}</div>
                }
                
            </StepLabel>
            <StepContent >
              <div style={{fontSize:'16px', marginLeft:'18px'}}> 
                {(activeStep === -1||activeStep === -2) ? "" : 
                index["description"].split("$&$").length > 1 ?
                index["description"].split("$&$").map((item) => {
                return (<ul style={{marginBottom:0}}><li style={{display: 'inline-flex'}}><span style={{width:'0', marginRight:'25px'}}><CheckCircleOutlineIcon className={classes.checkIcon}/></span><div style={{marginTop: '-2px', fontSize:'16px'}} dangerouslySetInnerHTML={{__html: item}}/></li></ul>)
                }) 
                :
                index["description"].split('\n').map((item) => {
                   if(item.split("&^&").length>1)
                    return(item.split("&^&").map((item1)=>{
                      return(<ul style={{marginBottom:0}}><li style={{display: 'inline-flex'}}><span style={{width:'0', marginRight:'25px', color:'#f7941e'}}><CheckCircleOutlineIcon className={classes.checkIcon}/></span><div style={{marginTop: '-2px', fontSize:'16px'}} dangerouslySetInnerHTML={{__html: item1}}/></li></ul>)
                    }))
                    else if(item.split("&_&").length>1)
                      return(item.split("&_&").map((item1)=>{
                        return(<ul style={{paddingLeft:10, marginBottom:0}}><li style={{display: 'inline-flex'}}><span style={{width:'0', marginRight:'25px', color:'#f7941e'}}><CheckCircleOutlineIcon className={classes.checkIcon}/></span><div style={{marginTop: '-2px', fontSize:'16px'}} dangerouslySetInnerHTML={{__html: item1}}/></li></ul>)
                      }))
                    
                    return(<div><div style={{marginBottom:'1%'}} dangerouslySetInnerHTML={{__html: item}}/></div>)                   
                })}
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}
